import { useQuery } from "@tanstack/react-query";
import { TableCard } from "ui-components/Layout";
import { ListLayout } from "ui-components/Layout";
import BasicTable from "ui-components/tables/BasicTable";
import { ReceivingScannedColumns } from "./columns";
import { useState } from "react";
import { useCustomerValue } from "providers/CustomerContext";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { CustomDateRangePicker } from "ui-components/CustomInput";
import dayjs from "dayjs";
import { Error_ } from "ui-components/Alert";
import { LoadingDialog } from "ui-components/Alert";
import { useTeamValue } from "providers/TeamContext";
import { Success, Error } from "ui-components/Alert";
import { ExportDialog } from "ui-components/Alert";
import useCsvDownloadHook from "hooks/useCsvDownloadHook";
import { getRecvWorkEnquiry } from "services/data.report.service";

function ReceivingScannedEnquiry() {
  const { permissions, allowAll } = useTeamValue();
  const { customerCode } = useCustomerValue();
  const [alert, setAlert] = useState(null);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const date = dayjs(new Date()).format("YYYY-MM-DD");
  const sevenDaysBefore = dayjs(new Date()).subtract(1, "day").format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(sevenDaysBefore);
  const [endDate, setEndDate] = useState(date);
  const { isDownloading, downloadCsv } = useCsvDownloadHook();
  const [type, setType] = useState("ALL");
  const { refetch, isFetching } = useQuery({
    queryKey: ["recv-work-enquiry", customerCode],
    queryFn: () => getRecvWorkEnquiry({ customerCode, startDate, endDate, type }),
    enabled: false,
    onSuccess: (data) => {
      setData(data.data.data);
      setFilteredData(data.data.data);
    },
    onError: () => { },
  });
  const exportPermission =
    allowAll ||
    (Boolean(permissions["Receiving Scanned_Report"]) &&
      permissions["Receiving Scanned_Report"].findIndex((b) => b === "export") !== -1);

  const customProps = { startDate, setStartDate, endDate, setEndDate };

  const handleFilterRowsChange = (filteredData) => {
    setFilteredData(filteredData);
  };

  const onFetch = () => {
    setAlert(null);
    const valid =
      dayjs(endDate).isSame(dayjs(startDate)) || dayjs(endDate).isAfter(dayjs(startDate));
    if (!valid) {
      setAlert(<Error_ content="Start date cannot greater than end date" onChange={setAlert} />);
      return;
    }
    if (dayjs(date).isBefore(endDate)) {
      setAlert(<Error_ content="End date cannot greater than today date" onChange={setAlert} />);
      return;
    }
    refetch();
  };
  const onSuccess = (data) => {
    setAlert(<Success data={data} onChange={setAlert} />);
  };
  const onError = (data) => {
    setAlert(<Error data={data} onChange={setAlert} />);
  };

  return (
    <ListLayout>
      {isFetching && <LoadingDialog />}
      {isDownloading && <ExportDialog />}
      {alert && <MDBox sx={{ my: 3 }}>{alert}</MDBox>}
      <TableCard sx={{ my: 3 }}>
        <MDBox margin="1rem 0 0 1rem">
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <CustomDateRangePicker {...customProps} />
            </Grid>
            <Grid item xs={3}>
              <MDButton
                variant="gradient"
                color="info"
                onClick={() => {
                  onFetch();
                }}
              >
                search
              </MDButton>
              <MDButton
                sx={{ marginLeft: "1rem" }}
                variant="gradient"
                color="info"
                disabled={!exportPermission}
                onClick={() => {
                  const filename = `${customerCode}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_ReceivingScanned`;
                  const data = filteredData;
                  downloadCsv(filename, data, ReceivingScannedColumns.map(x => ({label: x.header, key:x.accessorKey})));
                }}
              >
                export
              </MDButton>
            </Grid>
            {/* <Grid item xs={5}>
              <EmailButton2
                variant="gradient"
                color="info"
                filename={`${customerCode}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_ReceivingScanned`}
                startDate={startDate}
                endDate={endDate}
                onSuccess={onSuccess}
                onError={onError}
                customerCode={customerCode}
                type={"receiving-scanned"}
                dateType={type}
              />
            </Grid> */}
          </Grid>
          <Grid sx={{ paddingLeft: "12px" }}>
            <Grid item>
              <Grid item>
                            <RadioGroup
                              row
                              onChange={(e) => {
                                setType(e.target.value);
                              }}
                            >
                              <FormControlLabel
                                labelPlacement="left"
                                value="ALL"
                                label="All"
                                control={<Radio checked={type === "ALL"} />}
                              />
                              <FormControlLabel
                                labelPlacement="left"
                                value="PO"
                                label="PO"
                                control={<Radio checked={type === "PO"} />}
                              />
                              <FormControlLabel
                                labelPlacement="left"
                                value="CO"
                                label="CO"
                                control={<Radio checked={type === "CO"} />}
                              />
                              <FormControlLabel
                                labelPlacement="left"
                                value="MISC"
                                label="Misc"
                                control={<Radio checked={type === "MISC"} />}
                              />
                            </RadioGroup>
                          </Grid>
              <FormControl>
                <FormLabel
                  sx={{ color: "red", fontWeight: "bold", fontSize: "1rem", marginTop: ".5rem" }}
                >
                  * Click search button to load data
                </FormLabel>
              </FormControl>
            </Grid>
          </Grid>
        </MDBox>
        <BasicTable
          data={data}
          columns={ReceivingScannedColumns}
          onFilterRowsChange={handleFilterRowsChange}
        />
      </TableCard>
    </ListLayout>
  );
}

export default ReceivingScannedEnquiry;
